import { ODataObject } from '../../interfaces/odata-model.interface';
import { ConfigConstants } from '../../config/config-constants';

/**
 * Legacy view of an input field property. Instances are built from the store shape by
 * `inputFieldPropertyStateToModel`; the OData payload is assembled into that store shape by
 * `odataToInputFieldPropertyState`, which owns the wire-format coercion this class used to.
 */
export class InputFieldPropertyModel {
    public constructor(
        public screenName: string,
        public fieldName: string,
        public fieldValue: string,
        public screenPos: number,
        public fieldPos: number,
        public scannable: boolean,
        public mandatory: boolean,
        public readonly: boolean,
        public minLength: number,
        public maxLength: number,
        public minValue: number,
        public maxValue: number,
        public pattern: string,
        public patternScan: string,
        public valueHelperID: string,
        public process?: ConfigConstants.PROCESS_INDICATOR,
        public defaultValue?: string,
    ) {}
}

export interface ODataInputFieldPropertyModel extends ODataObject {
    ScreenName: string;
    FieldName: string;
    Process: string;
    FieldValue: string;
    ScreenPos: string;
    FieldPos: string;
    Scannable: string | boolean;
    Mandatory: string | boolean;
    ReadOnly: string | boolean;
    MinLength: string;
    MaxLength: string;
    MinValue: string;
    MaxValue: string;
    Pattern: string;
    PatternScan: string;
    ValueHelperID: string;
    DefaultValue: string;
}
